import { makeVar, useReactiveVar } from "@apollo/client"
import type { UserNotificationType } from "types"

function getNotifications(): UserNotificationType[] {
  if (typeof localStorage === "undefined") return []

  const notifications = localStorage.getItem("notifications")

  return notifications && notifications !== "undefined"
    ? JSON.parse(notifications)
    : []
}

const notificationsVar = makeVar<UserNotificationType[]>(getNotifications())

export function useNotifications(): {
  notifications: UserNotificationType[]
  globalNotifications: UserNotificationType[]
  rafNotifications: UserNotificationType[]
  accessPassNotifications: UserNotificationType[]
} {
  const allNotifications = useReactiveVar(notificationsVar)

  return {
    notifications: allNotifications,
    globalNotifications: allNotifications.filter((n) => n.handler === "global"),
    rafNotifications: allNotifications.filter((n) => n.handler === "raf"),
    accessPassNotifications: allNotifications.filter(
      (n) => n.handler === "access_pass"
    ),
  }
}

export function setNotifications(v: UserNotificationType[] | Error[]): void {
  notificationsVar(
    v
      ?.map((x) => {
        if (x instanceof Error) {
          return {
            code: x.message,
            level: "error",
            handler: "global",
            params: {},
          }
        }
        return x
      })
      .filter((x) => x)
  )

  const notifications = notificationsVar()
  if (typeof localStorage !== "undefined")
    localStorage.setItem("notifications", JSON.stringify(notifications))
}

export function setGlobalNotifications(
  v: UserNotificationType[] | Error[]
): void {
  const nonGlobal = notificationsVar().filter((n) => n.handler !== "global")
  const notificationsToSet = [...v, ...nonGlobal]
    ?.map((x) => {
      if (x instanceof Error) {
        return {
          code: x.message,
          level: "error",
          handler: "global",
          params: {},
        } as UserNotificationType
      }
      return x
    })
    .filter((x) => x)

  notificationsVar(notificationsToSet)

  const notifications = notificationsVar()
  if (typeof localStorage !== "undefined")
    localStorage.setItem("notifications", JSON.stringify(notifications))
}

export function clearNotifications(): void {
  setNotifications([])
  if (typeof localStorage !== "undefined")
    localStorage.removeItem("notifications")
}
